import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { DocumentForDownloadModel } from '../models/api/document-for-download.model';
import { DocumentForOverviewModel } from '../models/api/document-for-overview.model';
import { DocumentModel } from '../models/document.model';

@Injectable({
  providedIn: 'root'
})
export class DocumentApiClient {

  constructor(private httpClient: HttpClient) { }
  /**
   * Retrieves the document for Viewer
   * @param dossierId 
   * @param documentId 
   * @returns 
   */
  async getDocumentForViewer(dossierId: string, documentId: string) {
    return this.httpClient.get<DocumentModel>(environment.apiUrl + "/requests/" + dossierId + "/documents/" + documentId + "/viewer");
  }
  /**
   * Gets a Document list for Download page
   * @param requestGuid 
   * @returns 
   */
  getForDownloadList(requestGuid: string, downloadProofJwt: boolean = true): Observable<DocumentForDownloadModel[]> {
    let params = new HttpParams().set('downloadProofJwt', downloadProofJwt);
    return this.httpClient.get<DocumentForDownloadModel[]>(environment.apiUrl + "/requests/" + requestGuid + "/documents/downloadList", { params });
  }
  /**
   * Gets a Document list for status screen
   * @param requestGuid 
   * @returns 
   */
  getForOverview(requestGuid: string): Observable<DocumentForOverviewModel[]> {
    return this.httpClient.get<DocumentForOverviewModel[]>(environment.apiUrl + "/requests/" + requestGuid + "/documents/overview");
  }
  /**
   * Uploads a new Document for the given Request
   * @param dossierId 
   * @param formData 
   * @returns 
   */
  uploadNewDocument(dossierId: string, formData: FormData) {
    return this.httpClient.post(environment.apiUrl + "/requests/" + dossierId + "/documents/upload", formData);
  }

  async updateDocument(dossierId: string, documentId: string, name: string) {
    return this.httpClient.put(environment.apiUrl + "/requests/" + dossierId + "/documents/" + documentId, { "Name": name });
  }

  async updateDocumentPlaceholderId(dossierId: string, documentId: string, placeholderId: number) {
    return this.httpClient.put(environment.apiUrl + "/requests/" + dossierId + "/documents/" + documentId, { "WorkflowPlaceholderId": placeholderId.toString() });
  }

  async getDocument(dossierId: string, documentId: string) {
    return this.httpClient.get(environment.apiUrl + "/requests/" + dossierId + "/documents/" + documentId);
  }

  async getHtmlDetails(dossierId: string, documentId: string) {
    return this.httpClient.get(environment.apiUrl + "/requests/" + dossierId + "/documents/" + documentId + "/htmldata");
  }

  async getXBRLDetails(dossierId: string, documentId: string) {
    return this.httpClient.get(environment.apiUrl + "/requests/" + dossierId + "/documents/" + documentId + "/XBRLDetails");
  }

  async getRenderedHtml(dossierId: string, documentId: string) {
    const headers: HttpHeaders = new HttpHeaders({ 'Accept': 'text/html' });
    return this.httpClient.get(environment.apiUrl + "/requests/" + dossierId + "/documents/" + documentId + "/RenderedHtml", { headers: headers, responseType: 'text' });
  }
  async deleteDocument(dossierId: string, documentId: string) {
    return this.httpClient.delete(environment.apiUrl + "/requests/" + dossierId + "/documents/" + documentId);
  }


  approve(dossierId: string, documentId: string) {
    return this.httpClient.post<any>(environment.apiUrl + "/requests/" + dossierId + "/documents/" + documentId + "/Approve", {});
  }

  downloadDocument(dossierId: string, documentId: string) {
    return this.httpClient.get(environment.apiUrl + "/requests/" + dossierId + "/documents/" + documentId + "/Download", { observe: 'response', responseType: 'blob' });
  }

  downloadHtml(dossierId: string, documentId: string) {
    return this.httpClient.get(environment.apiUrl + "/requests/" + dossierId + "/documents/" + documentId + "/Downloadhtml", { observe: 'response', responseType: 'blob' });
  }

  downloadReviewCopy(dossierId: string, documentId: string) {
    return this.httpClient.get(environment.apiUrl + "/requests/" + dossierId + "/documents/" + documentId + "/Reviewcopy", { observe: 'response', responseType: 'blob' });
  }

}
